import { model } from 'hudl-base';

export function getAppSubdomainHost() {
  return window.location.host.includes('thorhudl.com')
    ? window.location.host.replace('thorhudl.com', 'app.thorhudl.com')
    : window.location.host.replace('hudl.com', 'app.hudl.com');
}

export function getCurrentTeamId() {
  return model.get()?.user?.currentTeamId ?? null;
}
